import React, { useMemo } from "react";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";

import { HubBackButton, HubFilterMenu } from "../../components";
import { FOUNDRIES } from "../../constants";
import { getAuthUser, getUserLocation } from "../../redux/auth";

import { DASHBOARD_VIEWS } from "./helper";
import { StyledTitleStack } from "./styles";
import { useUserHookFormList } from "../../components/UsersHookFormSelect";
import ChartRangeSlider from "./ChartRangeSlider";

export const DashboardPageBar = ({ period, setPeriod = () => {} }) => {
  const user = useSelector(getAuthUser);
  const defaultLocation = useSelector(getUserLocation);
  const defaultLocations = defaultLocation ? [Number(defaultLocation)] : [];

  const { users } = useUserHookFormList();

  const userOptions = [
    user?.id && { id: user?.id, label: `${user?.name} (Me)` || "Me" },
    users
      ?.filter((u) => u.id !== user?.id)
      .map((u) => ({ id: u.id, label: u.name || "Unkown" })),
  ].flat();

  return (
    <StyledTitleStack>
      <Stack direction="row" gap="10px" alignItems="center">
        <HubBackButton />
      </Stack>
      <Stack direction="row" gap="10px" alignItems="center">
        <ChartRangeSlider value={period} onChange={setPeriod} />
        <HubFilterMenu
          id="location"
          label="Location"
          menuLabel="Filter by location"
          icon="MapPin"
          options={FOUNDRIES}
          defaultValue={defaultLocations}
        />
        <HubFilterMenu
          id="view"
          label="View"
          menuLabel="Filter by view"
          icon="Filter"
          options={DASHBOARD_VIEWS}
          useDefault={false}
        />
        <HubFilterMenu
          id="userId"
          label="Created By"
          menuLabel="Filter by user"
          icon="User"
          options={userOptions}
          useDefault={false}
          searchable
          searchPlaceholder="Search users…"
        />
      </Stack>
    </StyledTitleStack>
  );
};

export default DashboardPageBar;
